// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-field-error {
    color: red;
    margin-top: 5px;
}

.form-field-warning {
    color: #b97e69;
    margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Error.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB","sourcesContent":[".form-field-error {\n    color: red;\n    margin-top: 5px;\n}\n\n.form-field-warning {\n    color: #b97e69;\n    margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
